export default __webpack_public_path__ + "static/media/help-16px.7fb62fd4.svg";